export const getPreliminarySession = state => state.preliminarySession;
